/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeEmailDto } from '../../models/employee-email-dto';

export interface EmployeeControllerGetMultipleEmployeeEmails$Params {
  ids: Array<number>;
}

export function employeeControllerGetMultipleEmployeeEmails(http: HttpClient, rootUrl: string, params: EmployeeControllerGetMultipleEmployeeEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeEmailDto>>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerGetMultipleEmployeeEmails.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeEmailDto>>;
    })
  );
}

employeeControllerGetMultipleEmployeeEmails.PATH = '/api/employee/employee-emails';
